module.exports = __webpack_public_path__ + "static/media/PP-logo.db1a17a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Other/PP-logo.png
// module id = 237
// module chunks = 0